import React from "react";
import styled from "styled-components";

import IndexListGroup from "./IndexListGroup";

const OuterWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Column = styled.div`
    margin-right: 20px;
    margin-bottom: 20px;
`;

const FewItemsColumn = styled(Column)`
    flex: 1;
`;

const ManyItemsColumn = styled(Column)`
    flex: 2;
    columns: 2;
    @media (max-width: 385px) {
        columns: 1;
    }
`;

const IndexList = ({ manyItemStates, fewItemStates }) => {
    return (
        <OuterWrapper id="locations-list">
            {manyItemStates.length === 1 && (
                <ManyItemsColumn>
                    <IndexListGroup state={manyItemStates[0]} />
                </ManyItemsColumn>
            )}
            {fewItemStates.length > 0 && (
                <FewItemsColumn>
                    {fewItemStates &&
                        fewItemStates.map((state, stateIndex) => (
                            <IndexListGroup key={stateIndex} state={state} />
                        ))}
                </FewItemsColumn>
            )}
        </OuterWrapper>
    );
};

export default IndexList;



// WEBPACK FOOTER //
// ./components/index/IndexList.jsx